import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productListStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListStyles.orderLinesList = mergeToNew(productListStyles.orderLinesList, {
    header: {
        color: "text.accent",
    },
});
